'use client'

import { useState, useContext } from 'react'
import { Modal, Typography } from 'antd'
import { AmplitudeContext } from '@/src/contexts/Amplitude/AmplitudeContext'

import { Button, BookingOptions } from '@/src/components'
import { Physician } from '@/src/interfaces'
import { trackBookingEvents } from '@/src/lib/analytics/events'

const { Title } = Typography

interface OnlineBookingButtonWithModalProps {
  physician: Physician
  physicianName: string
  locationType: 'Primary' | 'Additional'
  helpText?: boolean
}

export const OnlineBookingButtonWithModal = ({
  physician,
  physicianName,
  helpText = true,
}: OnlineBookingButtonWithModalProps) => {
  const [isModalVisible, setIsModalVisible] = useState(false)
  const { trackAmplitudeEvent } = useContext(AmplitudeContext)

  const handleOnlineBookingClick = () => {
    setIsModalVisible(true)
    trackBookingEvents.scheduleAppointmentClicked(trackAmplitudeEvent)({
      npi: physician.npi,
      full_name: physician.full_name,
      specialty: physician.specialty,
      city: physician.city,
      state: physician.state,
      position: 'Not Available',
    })
  }

  return (
    <>
      <div className='w-fit'>
        <Button
          type='primary'
          icon={'calendar-check'}
          onClick={handleOnlineBookingClick}
          text='Schedule Appointment'
        />
      </div>
      <Modal
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
      >
        <Title
          level={5}
          className='pr-2'
        >{`${physicianName}'s Online Booking`}</Title>
        <BookingOptions
          physician={physician}
          showOnlineBooking={true}
          helpText={helpText}
        />
      </Modal>
    </>
  )
}
